export default "__VITE_ASSET__B_1FY58j__"